"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoggerConf = exports.Logger = exports.initCustomLogger = void 0;
/* tslint:disable */
/* eslint:disable */
/**
 * @typedef {string} Url
 */
/**
 * @typedef {string} GUID
 */
/**
 * @typedef {number} DateTime
 */
var dummy;
var defaultConfig = { endpoint: 'membership' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign(__assign({}, defaultConfig), restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 92 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'membership' });
    }
    ;
    /**
    * @typedef {Object} membershipCancelledParams
    * @property {GUID} appInstanceId - app instance id
    * @property {string} expirationTime - expiration time of PP (now/period end)
    * @property {GUID} membershipId - membership guid
    * @property {GUID} biToken - metasite id
    * @property {GUID} planGuid - plan_guid
    * @property {number} planID - plan_id
    * @property {GUID} siteMemberId - site_member_id
    **/
    /**
     * Name: membership cancelled (deprecated). Evid: 13.
     * Event description: sent when a membership is cancelled.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * expirationTime - Type: string. Desc: expiration time of PP (now/period end)
     *
     * membershipId - Type: guid. Desc: membership guid
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * planGuid - Type: guid. Desc: plan_guid
     *
     * planID - Type: numeric. Desc: plan_id
     *
     * siteMemberId - Type: guid. Desc: site_member_id
     * @param {membershipCancelledParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.membershipCancelled = function (params) {
        return this.bi.log(__assign({ evid: 13 }, params));
    };
    /**
    * @typedef {Object} primaryPlanChangedParams
    * @property {GUID} appInstanceId - app instance id
    * @property {GUID} biToken - metasite id
    **/
    /**
     * Name: primary plan changed (deprecated). Evid: 19.
     * Event description: sent when the user changes primary plans.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * biToken - Type: guid. Desc: metasite id
     * @param {primaryPlanChangedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.primaryPlanChanged = function (params) {
        return this.bi.log(__assign({ evid: 19 }, params));
    };
    /**
    * @typedef {Object} thankYouPageCtaButtonClickParams
    * @property {GUID} appInstanceId - null
    * @property {string} buttonName - CTA button name at Thank You page
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Thank You page CTA button click. Evid: 52.
     * Event description: Event used to track Thank You page CTA button click..
    
     * appInstanceId - Type: guid.
     *
     * buttonName - Type: string. Desc: CTA button name at Thank You page
     *
     * biToken - Type: guid.
     * @param {thankYouPageCtaButtonClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.thankYouPageCtaButtonClick = function (params) {
        return this.bi.log(__assign({ evid: 52 }, params));
    };
    /**
    * @typedef {Object} connectionIntentParams
    * @property {GUID} appInstanceId - app id
    * @property {string} intentName - {connect or manage for WixApp only}
    * @property {GUID} biToken - msid
    * @property {string} origin - business manager open origin {editor, dashboard, etc}
    * @property {GUID} planGuid - plan guid
    * @property {string} serviceName - {bookings, challenges, forum, etc}
    **/
    /**
     * Name: connection intent. Evid: 50.
     * Event description: sent when user expresses intent to connect a plan to another service.
    
     * appInstanceId - Type: guid. Desc: app id
     *
     * intentName - Type: string. Desc: {connect or manage for WixApp only}
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: business manager open origin {editor, dashboard, etc}
     *
     * planGuid - Type: guid. Desc: plan guid
     *
     * serviceName - Type: string. Desc: {bookings, challenges, forum, etc}
     * @param {connectionIntentParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.connectionIntent = function (params) {
        return this.bi.log(__assign({ evid: 50 }, params));
    };
    /**
    * @typedef {Object} subscriptionInvoicesActionParams
    * @property {string} action - preview, ...
    * @property {GUID} appInstanceId - null
    * @property {GUID} invoiceId - invoice_id
    * @property {GUID} biToken - null
    * @property {GUID} subscriptionId - subscription_id
    **/
    /**
     * Name: Subscription Invoices action. Evid: 67.
     * Event description: Invoices actions at Single Subscription.
    
     * action - Type: string. Desc: preview, ...
     *
     * appInstanceId - Type: guid.
     *
     * invoiceId - Type: guid. Desc: invoice_id
     *
     * biToken - Type: guid.
     *
     * subscriptionId - Type: guid. Desc: subscription_id
     * @param {subscriptionInvoicesActionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.subscriptionInvoicesAction = function (params) {
        return this.bi.log(__assign({ evid: 67 }, params));
    };
    /**
    * @typedef {Object} widgetPlanCardCarouselSettingsSavedParams
    * @property {GUID} appInstanceId - App instance ID
    * @property {boolean} benefitsDisplayed - Enabled(True)/Disabled(False)
    * @property {GUID} biToken - msid
    * @property {string} planIDs - Enabled plans guids
    * @property {number} plans_count - number of enabled plans
    * @property {string} sectionLocationTab - About/Pricing
    * @property {boolean} sectionTitleState - Enabled(True)/Disabled(False)
    * @property {GUID} widgetId - Widget ID
    * @property {string} widgetType - WidgetType
    **/
    /**
     * Name: Widget - Plan card carousel - Settings saved. Evid: 72.
    
    
     * appInstanceId - Type: guid. Desc: App instance ID
     *
     * benefitsDisplayed - Type: bool. Desc: Enabled(True)/Disabled(False)
     *
     * biToken - Type: guid. Desc: msid
     *
     * planIDs - Type: string. Desc: Enabled plans guids
     *
     * plans_count - Type: numeric. Desc: number of enabled plans
     *
     * sectionLocationTab - Type: string. Desc: About/Pricing
     *
     * sectionTitleState - Type: bool. Desc: Enabled(True)/Disabled(False)
     *
     * widgetId - Type: guid. Desc: Widget ID
     *
     * widgetType - Type: string. Desc: WidgetType
     * @param {widgetPlanCardCarouselSettingsSavedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.widgetPlanCardCarouselSettingsSaved = function (params) {
        return this.bi.log(__assign({ evid: 72 }, params));
    };
    /**
    * @typedef {Object} membershipPurchaseEditedParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} fieldsUpdated - string of the fields that were changed
    * @property {GUID} membershipId - order_id that was edited
    * @property {GUID} biToken - msid
    * @property {GUID} planGuid - plan_guid
    * @property {GUID} site_member_id - site_member_id (of the purchase)
    **/
    /**
     * Name: Membership (purchase) edited (deprecated). Evid: 35.
     * Event description: When the user edits a purchase.
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * fieldsUpdated - Type: string. Desc: string of the fields that were changed
     *
     * membershipId - Type: guid. Desc: order_id that was edited
     *
     * biToken - Type: guid. Desc: msid
     *
     * planGuid - Type: guid. Desc: plan_guid
     *
     * site_member_id - Type: guid. Desc: site_member_id (of the purchase)
     * @param {membershipPurchaseEditedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.membershipPurchaseEdited = function (params) {
        return this.bi.log(__assign({ evid: 35 }, params));
    };
    /**
    * @typedef {Object} planPurchaseClickParams
    * @property {GUID} appInstanceId - app instance id
    * @property {GUID} biToken - metasite id
    * @property {GUID} planGuid - plan_guid
    * @property {number} planID - plan_id
    * @property {string} role - {owner,member,visitor}
    * @property {GUID} site_member_id - site_member_id
    * @property {GUID} visitor_id - visitor_id
    * @property {string} widgetType - widget type: list, featured and button,
    **/
    /**
     * Name: plan purchase click. Evid: 17.
     * Event description: sent when UoU clicks to purchase a plan.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * planGuid - Type: guid. Desc: plan_guid
     *
     * planID - Type: numeric. Desc: plan_id
     *
     * role - Type: string. Desc: {owner,member,visitor}
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * visitor_id - Type: guid. Desc: visitor_id
     *
     * widgetType - Type: string. Desc: widget type: list, featured and button,
     * @param {planPurchaseClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.planPurchaseClick = function (params) {
        return this.bi.log(__assign({ evid: 17 }, params));
    };
    /**
    * @typedef {Object} paidPlansAddPurchaseClickParams
    * @property {GUID} appInstanceId - null
    * @property {string} ctaType - null
    * @property {GUID} biToken - null
    * @property {string} origin - contacts panel, purchased plans page
    * @property {GUID} originAppId - app_id of vertical clicked at cta
    **/
    /**
     * Name: Offline Flow - add plan holder click. Evid: 29.
     * Event description: When the user(owner) clicks on add purchase in order to add a purchase manually.
    
     * appInstanceId - Type: guid.
     *
     * ctaType - Type: string.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: contacts panel, purchased plans page
     *
     * originAppId - Type: guid. Desc: app_id of vertical clicked at cta
     * @param {paidPlansAddPurchaseClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.paidPlansAddPurchaseClick = function (params) {
        return this.bi.log(__assign({ evid: 29 }, params));
    };
    /**
    * @typedef {Object} paidPlansAddedModalChoiceParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} choice - {close,CTA}
    * @property {GUID} biToken - msid
    * @property {string} viewMode - dashboard/editor
    **/
    /**
     * Name: Paid Plans added modal choice. Evid: 39.
     * Event description: sent when the user clicks on the modal (PP added SF) with his click - whether he clicked on the CTA or on X.
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * choice - Type: string. Desc: {close,CTA}
     *
     * biToken - Type: guid. Desc: msid
     *
     * viewMode - Type: string. Desc: dashboard/editor
     * @param {paidPlansAddedModalChoiceParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.paidPlansAddedModalChoice = function (params) {
        return this.bi.log(__assign({ evid: 39 }, params));
    };
    /**
    * @typedef {Object} widgetSettingsAddOnsModalActionsParams
    * @property {string} action - modal_open, add_intent, add_confirm
    * @property {GUID} appInstanceId - null
    * @property {GUID} biToken - null
    * @property {string} pageName - name of the page that widget was added to
    * @property {string} widgetType - the widget type
    **/
    /**
     * Name: Widget Settings Add-ons Modal Actions. Evid: 66.
     * Event description: Actions with Widget settings add-ons modal.
    
     * action - Type: string. Desc: modal_open, add_intent, add_confirm
     *
     * appInstanceId - Type: guid.
     *
     * biToken - Type: guid.
     *
     * pageName - Type: string. Desc: name of the page that widget was added to
     *
     * widgetType - Type: string. Desc: the widget type
     * @param {widgetSettingsAddOnsModalActionsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.widgetSettingsAddOnsModalActions = function (params) {
        return this.bi.log(__assign({ evid: 66 }, params));
    };
    /**
    * @typedef {Object} clickOnHidePlanParams
    * @property {GUID} appInstanceId - app instance id
    * @property {string} formOrigin - place where from plan was hidden: bo, modal
    * @property {GUID} biToken - metasite id
    * @property {GUID} planGuid - plan_guid
    * @property {number} planID - plan_id
    * @property {boolean} status - {hidden=T,unhidden=F}
    **/
    /**
     * Name: click on hide plan. Evid: 10.
     * Event description: sent when a user clicks on hide plan.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * formOrigin - Type: string. Desc: place where from plan was hidden: bo, modal
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * planGuid - Type: guid. Desc: plan_guid
     *
     * planID - Type: numeric. Desc: plan_id
     *
     * status - Type: bool. Desc: {hidden=T,unhidden=F}
     * @param {clickOnHidePlanParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickOnHidePlan = function (params) {
        return this.bi.log(__assign({ evid: 10 }, params));
    };
    /**
    * @typedef {Object} tabOpenedParams
    * @property {GUID} appInstanceId - app instance id
    * @property {boolean} isEmptyState - is_empty_state
    * @property {GUID} biToken - metasite id
    * @property {string} pageName - page name
    * @property {string} tabName - tab name
    **/
    /**
     * Name: tab opened (deprecated). Evid: 4.
     * Event description: sent when a tab is opened. sent with both page name and tab name.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * isEmptyState - Type: bool. Desc: is_empty_state
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * pageName - Type: string. Desc: page name
     *
     * tabName - Type: string. Desc: tab name
     * @param {tabOpenedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.tabOpened = function (params) {
        return this.bi.log(__assign({ evid: 4 }, params));
    };
    /**
    * @typedef {Object} plansPageViewParams
    * @property {GUID} appInstanceId - app instance id
    * @property {GUID} biToken - metasite id
    * @property {string} origin - editor, preview
    * @property {string} referralId - ID of the referring item - blog post id, event id, form category id
    * @property {string} referral_info - {bookings}
    * @property {string} role - {owner,member,visitor}
    * @property {GUID} site_member_id - site_member_id
    * @property {GUID} visitor_id - visitor_id
    * @property {string} widgetType - widget type: list, featured and button,
    **/
    /**
     * Name: plans page view. Evid: 16.
     * Event description: sent when UoU views the plans/memberships page.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * origin - Type: string. Desc: editor, preview
     *
     * referralId - Type: string. Desc: ID of the referring item - blog post id, event id, form category id
     *
     * referral_info - Type: string. Desc: {bookings}
     *
     * role - Type: string. Desc: {owner,member,visitor}
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * visitor_id - Type: guid. Desc: visitor_id
     *
     * widgetType - Type: string. Desc: widget type: list, featured and button,
     * @param {plansPageViewParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.plansPageView = function (params) {
        return this.bi.log(__assign({ evid: 16 }, params));
    };
    /**
    * @typedef {Object} manageAutomatonsClickParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} biToken - msid
    **/
    /**
     * Name: Manage automatons click (deprecated). Evid: 36.
     * Event description: When the user clicks on manage automations.
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * biToken - Type: guid. Desc: msid
     * @param {manageAutomatonsClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.manageAutomatonsClick = function (params) {
        return this.bi.log(__assign({ evid: 36 }, params));
    };
    /**
    * @typedef {Object} pricingPlansInvoicesToggleSwitchParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} biToken - null
    * @property {string} value - toggle_on, toggle_of, cancel, add
    **/
    /**
     * Name: Pricing Plans - Invoices settings. Evid: 64.
     * Event description: Sent on PP Invoices configuration..
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * biToken - Type: guid.
     *
     * value - Type: string. Desc: toggle_on, toggle_of, cancel, add
     * @param {pricingPlansInvoicesToggleSwitchParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.pricingPlansInvoicesToggleSwitch = function (params) {
        return this.bi.log(__assign({ evid: 64 }, params));
    };
    /**
    * @typedef {Object} addMembershipClickParams
    * @property {GUID} appInstanceId - app instance id
    * @property {GUID} biToken - metasite id
    * @property {GUID} siteMemberId - site_member_id
    **/
    /**
     * Name: add membership click (deprecated). Evid: 21.
     * Event description: sent when a user clicks on add new subscription.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * siteMemberId - Type: guid. Desc: site_member_id
     * @param {addMembershipClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.addMembershipClick = function (params) {
        return this.bi.log(__assign({ evid: 21 }, params));
    };
    /**
    * @typedef {Object} pricingPlansTaxToggleSwitchParams
    * @property {GUID} appInstanceId - null
    * @property {GUID} biToken - null
    * @property {string} value - {on/off}
    **/
    /**
     * Name: Pricing Plans - Tax toggle switch. Evid: 59.
     * Event description: sent on tax toggle switch by User. This indicates intent to add/change tax settings..
    
     * appInstanceId - Type: guid.
     *
     * biToken - Type: guid.
     *
     * value - Type: string. Desc: {on/off}
     * @param {pricingPlansTaxToggleSwitchParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.pricingPlansTaxToggleSwitch = function (params) {
        return this.bi.log(__assign({ evid: 59 }, params));
    };
    /**
    * @typedef {Object} sampleClientEventParams
    * @property {GUID} appInstanceId - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: sample-client-event. Evid: 1.
    
    
     * appInstanceId - Type: guid.
     *
     * biToken - Type: guid.
     * @param {sampleClientEventParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.sampleClientEvent = function (params) {
        return this.bi.log(__assign({ evid: 1 }, params));
    };
    /**
    * @typedef {Object} membershipSuspendedOrReactivatedParams
    * @property {string} action - 'suspend', 'suspend-confirm', 'reactivate', 'reactivate-confirm'
    * @property {GUID} appInstanceId - null
    * @property {GUID} membershipId - plan membership id
    * @property {GUID} biToken - null
    * @property {GUID} planGuid - plan guid
    * @property {GUID} siteMemberId - site member ID
    **/
    /**
     * Name: membership suspended or reactivated. Evid: 45.
     * Event description: sent when a membership is suspended or reactivated.
    
     * action - Type: string. Desc: 'suspend', 'suspend-confirm', 'reactivate', 'reactivate-confirm'
     *
     * appInstanceId - Type: guid.
     *
     * membershipId - Type: guid. Desc: plan membership id
     *
     * biToken - Type: guid.
     *
     * planGuid - Type: guid. Desc: plan guid
     *
     * siteMemberId - Type: guid. Desc: site member ID
     * @param {membershipSuspendedOrReactivatedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.membershipSuspendedOrReactivated = function (params) {
        return this.bi.log(__assign({ evid: 45 }, params));
    };
    /**
    * @typedef {Object} managePlansLoadedParams
    * @property {GUID} appInstanceId - app instance id
    * @property {GUID} biToken - metasite id
    * @property {string} origin - {BizMgr,Editor,other app name}
    * @property {string} referralInfo - referralInfo = internal when User comes back e.g. plan creation form
    **/
    /**
     * Name: BO loaded. Evid: 2.
     * Event description: sent when the 'manage plans' in BO is loaded SF. referralInfo = internal when User comes back e.g. plan creation form.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * origin - Type: string. Desc: {BizMgr,Editor,other app name}
     *
     * referralInfo - Type: string. Desc: referralInfo = internal when User comes back e.g. plan creation form
     * @param {managePlansLoadedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.managePlansLoaded = function (params) {
        return this.bi.log(__assign({ evid: 2 }, params));
    };
    /**
    * @typedef {Object} singlePurchasePageLoadedParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} biToken - msid
    * @property {GUID} planGuid - plan_guid
    * @property {GUID} site_member_id - site_member_id
    * @property {string} viewer - {'owner','member'}
    **/
    /**
     * Name: Offline Flow - single purchase page loaded. Evid: 32.
     * Event description: When the user (owner) clicks to add a new client in order to add a purchase for him.
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * planGuid - Type: guid. Desc: plan_guid
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * viewer - Type: string. Desc: {'owner','member'}
     * @param {singlePurchasePageLoadedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.singlePurchasePageLoaded = function (params) {
        return this.bi.log(__assign({ evid: 32 }, params));
    };
    /**
    * @typedef {Object} checkoutStageParams
    * @property {GUID} appInstanceId - null
    * @property {GUID} biToken - msid
    * @property {GUID} planGuid - plan guid
    * @property {string} stage - stages of the checkout process {checkout screen loaded, auth-method-signup, auth-method-login, etc}
    **/
    /**
     * Name: Checkout stage. Evid: 46.
     * Event description: sent when UoU goes through different stages of the checkout flow.
    
     * appInstanceId - Type: guid.
     *
     * biToken - Type: guid. Desc: msid
     *
     * planGuid - Type: guid. Desc: plan guid
     *
     * stage - Type: string. Desc: stages of the checkout process {checkout screen loaded, auth-method-signup, auth-method-login, etc}
     * @param {checkoutStageParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.checkoutStage = function (params) {
        return this.bi.log(__assign({ evid: 46 }, params));
    };
    /**
    * @typedef {Object} connectPlanClickParams
    * @property {GUID} appInstanceId - app instance id
    * @property {string} formOrigin - indicates where the form was opened {bookings, blog, events etc)
    * @property {GUID} biToken - metasite ID
    * @property {string} origin - business manager open origin {editor, dashboard, etc}
    * @property {GUID} planGuid - plan ID
    * @property {string} value - indicates if the plan was connected or disconnected {connect/disconnect/save (WixApp)}
    **/
    /**
     * Name: Connect plan click. Evid: 44.
     * Event description: sent when User clicks on Connect button to connect a plan to a service/post/etc (in connect modal from vertical side).
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * formOrigin - Type: string. Desc: indicates where the form was opened {bookings, blog, events etc)
     *
     * biToken - Type: guid. Desc: metasite ID
     *
     * origin - Type: string. Desc: business manager open origin {editor, dashboard, etc}
     *
     * planGuid - Type: guid. Desc: plan ID
     *
     * value - Type: string. Desc: indicates if the plan was connected or disconnected {connect/disconnect/save (WixApp)}
     * @param {connectPlanClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.connectPlanClick = function (params) {
        return this.bi.log(__assign({ evid: 44 }, params));
    };
    /**
    * @typedef {Object} actionButtonClickedParams
    * @property {string} action - {edit/archive/hide} hide option exists only in OneApp
    * @property {GUID} appInstanceId - app instance id
    * @property {string} formOrigin - where it was clicked from e.g. editor settings
    * @property {GUID} biToken - metasite id
    * @property {string} origin - business manager open origin {editor, dashboard, etc}
    * @property {GUID} planGuid - plan_guid
    * @property {number} planID - plan_id
    **/
    /**
     * Name: action button clicked. Evid: 11.
     * Event description: sent when a user chooses an action under the action button. not sent for the action button click, but for the following click on a specific action.
    
     * action - Type: string. Desc: {edit/archive/hide} hide option exists only in OneApp
     *
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * formOrigin - Type: string. Desc: where it was clicked from e.g. editor settings
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * origin - Type: string. Desc: business manager open origin {editor, dashboard, etc}
     *
     * planGuid - Type: guid. Desc: plan_guid
     *
     * planID - Type: numeric. Desc: plan_id
     * @param {actionButtonClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.actionButtonClicked = function (params) {
        return this.bi.log(__assign({ evid: 11 }, params));
    };
    /**
    * @typedef {Object} pricingPlansTaxSettingsSavedParams
    * @property {GUID} appInstanceId - null
    * @property {boolean} invoicesToggle - INVOICES toggle on or off
    * @property {GUID} biToken - null
    * @property {number} taxRate - tax rate e.g. if 20% show as '20'
    * @property {string} taxType - type of tax {included/added}
    * @property {boolean} toggle - TAX toggle on or off
    **/
    /**
     * Name: Pricing Plans - Settings saved. Evid: 60.
     * Event description: send when User saves tax settings in the Pricing Plans settings.
    
     * appInstanceId - Type: guid.
     *
     * invoicesToggle - Type: bool. Desc: INVOICES toggle on or off
     *
     * biToken - Type: guid.
     *
     * taxRate - Type: numeric. Desc: tax rate e.g. if 20% show as '20'
     *
     * taxType - Type: string. Desc: type of tax {included/added}
     *
     * toggle - Type: bool. Desc: TAX toggle on or off
     * @param {pricingPlansTaxSettingsSavedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.pricingPlansTaxSettingsSaved = function (params) {
        return this.bi.log(__assign({ evid: 60 }, params));
    };
    /**
    * @typedef {Object} planCreatedParams
    * @property {boolean} allowCancel - allow subscriptions cancellations: true/false
    * @property {boolean} allowCustomStart - allowing custom start date: true/false
    * @property {GUID} appInstanceId - app instance id
    * @property {string} currency - currency
    * @property {number} duration - plan duration in months
    * @property {string} durationUnit - weeks, months, years
    * @property {string} formOrigin - indicates where the plan form was opened from {bookings modal, bizmgr)
    * @property {number} freeTrialDays - trial duration in days
    * @property {boolean} hasDisclaimer - true if the disclaimer is used; false otherwise
    * @property {string} integratedVerticals - array of verticals that are being integrated
    * @property {boolean} isTaglineFilled - tag line filled {T/F}
    * @property {GUID} biToken - metasite id
    * @property {number} numOfBenefits - number of benefits defined by the user
    * @property {string} origin - {paid plans, bookings,pages} or other relevant vertical
    * @property {string} payment - price
    * @property {string} paymentMode - {one time, monthly}
    * @property {GUID} planGuid - plan_guid
    * @property {number} planID - plan_id
    * @property {string} planTitle - plan title
    * @property {number} price - plan price (multiplied by 100 to remove decimal)
    * @property {number} purchaseLimit - limit  of purchases for plan
    * @property {string} referralInfo - referral info
    **/
    /**
     * Name: plan created. Evid: 9.
     * Event description: sent when a plan was created SF.
    
     * allowCancel - Type: bool. Desc: allow subscriptions cancellations: true/false
     *
     * allowCustomStart - Type: bool. Desc: allowing custom start date: true/false
     *
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * currency - Type: string. Desc: currency
     *
     * duration - Type: numeric. Desc: plan duration in months
     *
     * durationUnit - Type: string. Desc: weeks, months, years
     *
     * formOrigin - Type: string. Desc: indicates where the plan form was opened from {bookings modal, bizmgr)
     *
     * freeTrialDays - Type: numeric. Desc: trial duration in days
     *
     * hasDisclaimer - Type: bool. Desc: true if the disclaimer is used; false otherwise
     *
     * integratedVerticals - Type: string. Desc: array of verticals that are being integrated
     *
     * isTaglineFilled - Type: bool. Desc: tag line filled {T/F}
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * numOfBenefits - Type: numeric. Desc: number of benefits defined by the user
     *
     * origin - Type: string. Desc: {paid plans, bookings,pages} or other relevant vertical
     *
     * payment - Type: string. Desc: price
     *
     * paymentMode - Type: string. Desc: {one time, monthly}
     *
     * planGuid - Type: guid. Desc: plan_guid
     *
     * planID - Type: numeric. Desc: plan_id
     *
     * planTitle - Type: string. Desc: plan title
     *
     * price - Type: numeric. Desc: plan price (multiplied by 100 to remove decimal)
     *
     * purchaseLimit - Type: numeric. Desc: limit  of purchases for plan
     *
     * referralInfo - Type: string. Desc: referral info
     * @param {planCreatedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.planCreated = function (params) {
        return this.bi.log(__assign({ evid: 9 }, params));
    };
    /**
    * @typedef {Object} planPurchasedParams
    * @property {GUID} appInstanceId - app instance id
    * @property {string} currency - currency
    * @property {number} duration - plan duration in months
    * @property {GUID} membershipId - membership_id
    * @property {GUID} biToken - metasite id
    * @property {string} payment - price in string
    * @property {string} paymentMethodType - credit card, pay pal, etc
    * @property {string} paymentStatus - approved, not approved, etc
    * @property {string} paymentType - {recurring,one-time}
    * @property {GUID} planGuid - plan_guid
    * @property {number} planID - plan_id
    * @property {number} price - price
    * @property {string} role - {owner,member,visitor}
    * @property {GUID} site_member_id - site_member_id
    * @property {GUID} transactionId - cashier's transaction_id
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: plan purchased. Evid: 20.
     * Event description: sent when purchased was made.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * currency - Type: string. Desc: currency
     *
     * duration - Type: numeric. Desc: plan duration in months
     *
     * membershipId - Type: guid. Desc: membership_id
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * payment - Type: string. Desc: price in string
     *
     * paymentMethodType - Type: string. Desc: credit card, pay pal, etc
     *
     * paymentStatus - Type: string. Desc: approved, not approved, etc
     *
     * paymentType - Type: string. Desc: {recurring,one-time}
     *
     * planGuid - Type: guid. Desc: plan_guid
     *
     * planID - Type: numeric. Desc: plan_id
     *
     * price - Type: numeric. Desc: price
     *
     * role - Type: string. Desc: {owner,member,visitor}
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * transactionId - Type: guid. Desc: cashier's transaction_id
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {planPurchasedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.planPurchased = function (params) {
        return this.bi.log(__assign({ evid: 20 }, params));
    };
    /**
    * @typedef {Object} planFormOpenedParams
    * @property {GUID} appInstanceId - app instance id
    * @property {string} formOrigin - indicates where the plan form was opened from {bookings modal, bizmgr, etc)
    * @property {boolean} is_archived - indicates if the plan viewed is archived
    * @property {GUID} biToken - metasite id
    * @property {string} origin - dashboard/editor
    * @property {string} referralInfo - referral info
    **/
    /**
     * Name: plan form opened. Evid: 6.
     * Event description: sent when the plan form page is loaded SF.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * formOrigin - Type: string. Desc: indicates where the plan form was opened from {bookings modal, bizmgr, etc)
     *
     * is_archived - Type: bool. Desc: indicates if the plan viewed is archived
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * origin - Type: string. Desc: dashboard/editor
     *
     * referralInfo - Type: string. Desc: referral info
     * @param {planFormOpenedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.planFormOpened = function (params) {
        return this.bi.log(__assign({ evid: 6 }, params));
    };
    /**
    * @typedef {Object} purchasedPlansLoadedParams
    * @property {number} activeMemberships - as appears to user
    * @property {number} activePurchases - as appears to users
    * @property {GUID} appInstanceId - app instance id
    * @property {boolean} isEmptyState - is_empty_state
    * @property {GUID} biToken - metasite id
    * @property {number} totalPurchases - as appears to user
    **/
    /**
     * Name: purchased plans loaded (deprecated). Evid: 3.
     * Event description: sent when the 'purchased plans' in BO is loaded SF..
    
     * activeMemberships - Type: numeric. Desc: as appears to user
     *
     * activePurchases - Type: numeric. Desc: as appears to users
     *
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * isEmptyState - Type: bool. Desc: is_empty_state
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * totalPurchases - Type: numeric. Desc: as appears to user
     * @param {purchasedPlansLoadedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.purchasedPlansLoaded = function (params) {
        return this.bi.log(__assign({ evid: 3 }, params));
    };
    /**
    * @typedef {Object} editPurchaseClickParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} membershipId - purchase id
    * @property {GUID} biToken - msid
    * @property {GUID} planGuid - plan_guid
    * @property {GUID} site_member_id - site_member_id (of the purchase)
    **/
    /**
     * Name: Edit purchase Click (deprecated). Evid: 34.
     * Event description: When the user clicks on edit purchase.
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * membershipId - Type: guid. Desc: purchase id
     *
     * biToken - Type: guid. Desc: msid
     *
     * planGuid - Type: guid. Desc: plan_guid
     *
     * site_member_id - Type: guid. Desc: site_member_id (of the purchase)
     * @param {editPurchaseClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editPurchaseClick = function (params) {
        return this.bi.log(__assign({ evid: 34 }, params));
    };
    /**
    * @typedef {Object} pricingPlansErrorParams
    * @property {GUID} appInstanceId - null
    * @property {string} errorMsg - error message text
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Pricing Plans Error. Evid: 63.
     * Event description: sent when error is fired anywhere within Pricing Plans app.
    
     * appInstanceId - Type: guid.
     *
     * errorMsg - Type: string. Desc: error message text
     *
     * biToken - Type: guid.
     * @param {pricingPlansErrorParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.pricingPlansError = function (params) {
        return this.bi.log(__assign({ evid: 63 }, params));
    };
    /**
    * @typedef {Object} membershipMarkedAsPaidParams
    * @property {string} action - complete/complete-confirm
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} biToken - null
    * @property {DateTime} startDate - order start date
    * @property {GUID} planGuid - plan_guid
    * @property {GUID} site_member_id - site_member_id
    * @property {boolean} status - T-Paid, F-Unpaid
    **/
    /**
     * Name: Offline Flow - membership marked as paid. Evid: 33.
     * Event description: When the user (owner) marks membership as paid.
    
     * action - Type: string. Desc: complete/complete-confirm
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * biToken - Type: guid.
     *
     * startDate - Type: datetime. Desc: order start date
     *
     * planGuid - Type: guid. Desc: plan_guid
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * status - Type: bool. Desc: T-Paid, F-Unpaid
     * @param {membershipMarkedAsPaidParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.membershipMarkedAsPaid = function (params) {
        return this.bi.log(__assign({ evid: 33 }, params));
    };
    /**
    * @typedef {Object} connectedServicesUpdatedParams
    * @property {GUID} appInstanceId - app id
    * @property {GUID} biToken - null
    * @property {GUID} planGuid - plan guid
    * @property {string} serviceName - {bookings,challenges, forum, etc}
    **/
    /**
     * Name: connected services updated. Evid: 51.
     * Event description: sent when user successfully updates services connected to a plan.
    
     * appInstanceId - Type: guid. Desc: app id
     *
     * biToken - Type: guid.
     *
     * planGuid - Type: guid. Desc: plan guid
     *
     * serviceName - Type: string. Desc: {bookings,challenges, forum, etc}
     * @param {connectedServicesUpdatedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.connectedServicesUpdated = function (params) {
        return this.bi.log(__assign({ evid: 51 }, params));
    };
    /**
    * @typedef {Object} pricingPlansSettingsPanelOpenedParams
    * @property {GUID} appInstanceId - null
    * @property {GUID} biToken - null
    * @property {string} origin - dashboard/editor
    * @property {string} referralInfo - place where it was referred from {pricing plans go to cta, eCom settings, etc}
    * @property {string} tabName - name of the tab
    **/
    /**
     * Name: Pricing Plans settings panel opened. Evid: 61.
     * Event description: sent when pricing plans settings are opened within Site settings.
    
     * appInstanceId - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: dashboard/editor
     *
     * referralInfo - Type: string. Desc: place where it was referred from {pricing plans go to cta, eCom settings, etc}
     *
     * tabName - Type: string. Desc: name of the tab
     * @param {pricingPlansSettingsPanelOpenedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.pricingPlansSettingsPanelOpened = function (params) {
        return this.bi.log(__assign({ evid: 61 }, params));
    };
    /**
    * @typedef {Object} planPurchaseFlowOneAppIapParams
    * @property {GUID} appInstanceId - app instance id
    * @property {GUID} biToken - msid
    * @property {GUID} planGuid - plan_guid
    * @property {string} role - {owner,member,visitor}
    * @property {GUID} site_member_id - site_member_id
    * @property {string} stage - plan-details/pre-chat
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Plan Purchase Flow - OneApp (IAP). Evid: 70.
     * Event description: This event will be used for IAP flow. Where UoU has to reach (via chat) User in order to buy the plan..
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * biToken - Type: guid. Desc: msid
     *
     * planGuid - Type: guid. Desc: plan_guid
     *
     * role - Type: string. Desc: {owner,member,visitor}
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * stage - Type: string. Desc: plan-details/pre-chat
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {planPurchaseFlowOneAppIapParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.planPurchaseFlowOneAppIap = function (params) {
        return this.bi.log(__assign({ evid: 70 }, params));
    };
    /**
    * @typedef {Object} cancelMembershipClickParams
    * @property {GUID} appInstanceId - app instance id
    * @property {boolean} isOwner - true if its in the owner's view, false if the member cancel his plan
    * @property {GUID} membershipId - membership guid
    * @property {GUID} biToken - metasite id
    * @property {GUID} planGuid - plan_guid
    * @property {number} planID - deprecated
    * @property {GUID} siteMemberId - site_member_id
    **/
    /**
     * Name: cancel membership click (deprecated). Evid: 12.
     * Event description: sent when a owner/member clicks on cancel membership.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * isOwner - Type: bool. Desc: true if its in the owner's view, false if the member cancel his plan
     *
     * membershipId - Type: guid. Desc: membership guid
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * planGuid - Type: guid. Desc: plan_guid
     *
     * planID - Type: numeric. Desc: deprecated
     *
     * siteMemberId - Type: guid. Desc: site_member_id
     * @param {cancelMembershipClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.cancelMembershipClick = function (params) {
        return this.bi.log(__assign({ evid: 12 }, params));
    };
    /**
    * @typedef {Object} planSettingsPanelOpenParams
    * @property {GUID} appInstanceId - null
    * @property {GUID} biToken - null
    * @property {GUID} widgetId - id of widget
    * @property {string} widgetType - pre-widget, list, single, button - widget types
    **/
    /**
     * Name: Editor Plan settings panel open. Evid: 55.
     * Event description: Sent when plan settings panel opens currently from widget only.
    
     * appInstanceId - Type: guid.
     *
     * biToken - Type: guid.
     *
     * widgetId - Type: guid. Desc: id of widget
     *
     * widgetType - Type: string. Desc: pre-widget, list, single, button - widget types
     * @param {planSettingsPanelOpenParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.planSettingsPanelOpen = function (params) {
        return this.bi.log(__assign({ evid: 55 }, params));
    };
    /**
    * @typedef {Object} upgradeReferralClickParams
    * @property {GUID} appInstanceId - app id
    * @property {boolean} isPreview - indicates if clicked in preview mode
    * @property {GUID} biToken - null
    * @property {string} referralInfo - e.g. {toast, modal, BO}
    **/
    /**
     * Name: Upgrade CTA click. Evid: 47.
     * Event description: sent when a User clicks on a link to Upgrade to Premium.
    
     * appInstanceId - Type: guid. Desc: app id
     *
     * isPreview - Type: bool. Desc: indicates if clicked in preview mode
     *
     * biToken - Type: guid.
     *
     * referralInfo - Type: string. Desc: e.g. {toast, modal, BO}
     * @param {upgradeReferralClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.upgradeReferralClick = function (params) {
        return this.bi.log(__assign({ evid: 47 }, params));
    };
    /**
    * @typedef {Object} myPaidPlansPageLoadedParams
    * @property {GUID} appInstanceId - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: My paid plans page - loaded. Evid: 23.
     * Event description: When My Paid plans page on OneApp was loaded successfully.
    
     * appInstanceId - Type: guid.
     *
     * biToken - Type: guid.
     * @param {myPaidPlansPageLoadedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.myPaidPlansPageLoaded = function (params) {
        return this.bi.log(__assign({ evid: 23 }, params));
    };
    /**
    * @typedef {Object} createPlanClickParams
    * @property {GUID} appInstanceId - app instance id
    * @property {string} formOrigin - indicates where the plan form was opened from {bookings modal, bizmgr, etc)
    * @property {GUID} biToken - metasite id
    * @property {string} referralInfo - referrer info
    **/
    /**
     * Name: create plan click. Evid: 5.
     * Event description: sent when the user clicks 'create a plan'.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * formOrigin - Type: string. Desc: indicates where the plan form was opened from {bookings modal, bizmgr, etc)
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * referralInfo - Type: string. Desc: referrer info
     * @param {createPlanClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.createPlanClick = function (params) {
        return this.bi.log(__assign({ evid: 5 }, params));
    };
    /**
    * @typedef {Object} introducingSubscriptionsParams
    * @property {GUID} appInstanceId - app id
    * @property {string} interaction_type - {Sidebar_menu_new_badge,pricing_plans_info_box}
    * @property {GUID} biToken - null
    * @property {string} origin - dashboard/editor
    **/
    /**
     * Name: introducing subscriptions (deprecated). Evid: 49.
     * Event description: sent when a User interacts with one of the introductory messages/cta to a new subscription feature.
    
     * appInstanceId - Type: guid. Desc: app id
     *
     * interaction_type - Type: string. Desc: {Sidebar_menu_new_badge,pricing_plans_info_box}
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: dashboard/editor
     * @param {introducingSubscriptionsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.introducingSubscriptions = function (params) {
        return this.bi.log(__assign({ evid: 49 }, params));
    };
    /**
    * @typedef {Object} myPaidPlansSwitchTabParams
    * @property {GUID} appInstanceId - null
    * @property {string} currentTab - Active/Expired
    * @property {GUID} biToken - null
    * @property {string} targetTab - Active/Expired
    **/
    /**
     * Name: My paid plans - switch tab. Evid: 24.
     * Event description: When the user switches between Active and expired tabs.
    
     * appInstanceId - Type: guid.
     *
     * currentTab - Type: string. Desc: Active/Expired
     *
     * biToken - Type: guid.
     *
     * targetTab - Type: string. Desc: Active/Expired
     * @param {myPaidPlansSwitchTabParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.myPaidPlansSwitchTab = function (params) {
        return this.bi.log(__assign({ evid: 24 }, params));
    };
    /**
    * @typedef {Object} memberProfilePaidPlansPlanThreeDotsActionButtonParams
    * @property {GUID} appInstanceId - null
    * @property {GUID} biToken - null
    * @property {string} value - (Edit plan, Cancel subscription etc..)
    **/
    /**
     * Name: Member profile - Paid plans - plan three dots - action button. Evid: 28.
     * Event description: When one of the action buttons in the plan page of a member was clicked.
    
     * appInstanceId - Type: guid.
     *
     * biToken - Type: guid.
     *
     * value - Type: string. Desc: (Edit plan, Cancel subscription etc..)
     * @param {memberProfilePaidPlansPlanThreeDotsActionButtonParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.memberProfilePaidPlansPlanThreeDotsActionButton = function (params) {
        return this.bi.log(__assign({ evid: 28 }, params));
    };
    /**
    * @typedef {Object} ppMiscClickParams
    * @property {GUID} appInstanceId - null
    * @property {GUID} biToken - null
    * @property {string} referralInfo - identifier of a button, link
    **/
    /**
     * Name: PP Misc Click. Evid: 65.
     * Event description: Buttons/links/etc clicks at random places..
    
     * appInstanceId - Type: guid.
     *
     * biToken - Type: guid.
     *
     * referralInfo - Type: string. Desc: identifier of a button, link
     * @param {ppMiscClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.ppMiscClick = function (params) {
        return this.bi.log(__assign({ evid: 65 }, params));
    };
    /**
    * @typedef {Object} viewPlansClickInContactPanelParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} biToken - msid
    * @property {GUID} siteMemberId - the member the user is looking at
    **/
    /**
     * Name: view plans click in contact panel. Evid: 40.
     * Event description: sent when the user clicks 'view plans' in the contact panel, to view all the members' plans.
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * siteMemberId - Type: guid. Desc: the member the user is looking at
     * @param {viewPlansClickInContactPanelParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.viewPlansClickInContactPanel = function (params) {
        return this.bi.log(__assign({ evid: 40 }, params));
    };
    /**
    * @typedef {Object} pricingPlansSettingsClickParams
    * @property {GUID} appInstanceId - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Pricing plans settings click. Evid: 62.
     * Event description: sent when "manage pricing plans" option is clicked form Manage Panel.
    
     * appInstanceId - Type: guid.
     *
     * biToken - Type: guid.
     * @param {pricingPlansSettingsClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.pricingPlansSettingsClick = function (params) {
        return this.bi.log(__assign({ evid: 62 }, params));
    };
    /**
    * @typedef {Object} planSaveClickParams
    * @property {boolean} allowCancel - allow subscriptions cancellations: true/false
    * @property {boolean} allowCustomStart - allowing custom start date: true/false
    * @property {GUID} appInstanceId - app instance id
    * @property {string} currency - currency
    * @property {number} duration - plan duration in months
    * @property {string} durationUnit - weeks, months, years
    * @property {string} formOrigin - indicates where the plan form was opened from {bookings modal, bizmgr)
    * @property {number} freeTrialDays - trial duration in days
    * @property {boolean} hasDisclaimer - true if the disclaimer is used; false otherwise
    * @property {string} integratedVerticals - array of verticals that are being integrated
    * @property {boolean} isTaglineFilled - tag line filled {T/F}
    * @property {GUID} biToken - metasite id
    * @property {number} numOfBenefits - number of benefits defined by the user
    * @property {string} origin - {paid plans, bookings,pages} or other relevant vertical
    * @property {string} payment - price
    * @property {string} paymentMode - {one time, monthly}
    * @property {GUID} planGuid - plan_guid
    * @property {number} planID - plan_id
    * @property {string} planTitle - plan title
    * @property {number} price - plan price
    * @property {number} purchaseLimit - limit  of purchases for plan
    * @property {string} referralInfo - referral info
    **/
    /**
     * Name: plan save click. Evid: 8.
     * Event description: sent when the user clicks on 'save plan'.
    
     * allowCancel - Type: bool. Desc: allow subscriptions cancellations: true/false
     *
     * allowCustomStart - Type: bool. Desc: allowing custom start date: true/false
     *
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * currency - Type: string. Desc: currency
     *
     * duration - Type: numeric. Desc: plan duration in months
     *
     * durationUnit - Type: string. Desc: weeks, months, years
     *
     * formOrigin - Type: string. Desc: indicates where the plan form was opened from {bookings modal, bizmgr)
     *
     * freeTrialDays - Type: numeric. Desc: trial duration in days
     *
     * hasDisclaimer - Type: bool. Desc: true if the disclaimer is used; false otherwise
     *
     * integratedVerticals - Type: string. Desc: array of verticals that are being integrated
     *
     * isTaglineFilled - Type: bool. Desc: tag line filled {T/F}
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * numOfBenefits - Type: numeric. Desc: number of benefits defined by the user
     *
     * origin - Type: string. Desc: {paid plans, bookings,pages} or other relevant vertical
     *
     * payment - Type: string. Desc: price
     *
     * paymentMode - Type: string. Desc: {one time, monthly}
     *
     * planGuid - Type: guid. Desc: plan_guid
     *
     * planID - Type: numeric. Desc: plan_id
     *
     * planTitle - Type: string. Desc: plan title
     *
     * price - Type: numeric. Desc: plan price
     *
     * purchaseLimit - Type: numeric. Desc: limit  of purchases for plan
     *
     * referralInfo - Type: string. Desc: referral info
     * @param {planSaveClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.planSaveClick = function (params) {
        return this.bi.log(__assign({ evid: 8 }, params));
    };
    /**
    * @typedef {Object} offlineFlowChangeStartDateParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} biToken - msid
    * @property {DateTime} startDate - order start date
    * @property {GUID} planGuid - plan guid
    * @property {GUID} site_member_id - contact_id to whom plan was sold
    * @property {boolean} status - T-Paid, F-Unpaid
    **/
    /**
     * Name: Offline Flow - plan info changes. Evid: 68.
     * Event description: When the user (owner) change start date.
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * startDate - Type: datetime. Desc: order start date
     *
     * planGuid - Type: guid. Desc: plan guid
     *
     * site_member_id - Type: guid. Desc: contact_id to whom plan was sold
     *
     * status - Type: bool. Desc: T-Paid, F-Unpaid
     * @param {offlineFlowChangeStartDateParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.offlineFlowChangeStartDate = function (params) {
        return this.bi.log(__assign({ evid: 68 }, params));
    };
    /**
    * @typedef {Object} settingsOpenedParams
    * @property {GUID} appInstanceId - app instance id
    * @property {GUID} biToken - metasite id
    * @property {string} referralInfo - place where it was navigated form
    **/
    /**
     * Name: settings opened. Evid: 15.
     * Event description: sent when the app settings are loaded SF..
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * referralInfo - Type: string. Desc: place where it was navigated form
     * @param {settingsOpenedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.settingsOpened = function (params) {
        return this.bi.log(__assign({ evid: 15 }, params));
    };
    /**
    * @typedef {Object} paidPlansAddedModalAppearParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} biToken - msid
    * @property {string} viewMode - dashboard, editor
    **/
    /**
     * Name: Paid Plans added modal appear. Evid: 38.
     * Event description: sent when PP is added to the stage, and the user sees a modal in the BizMgr.
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * viewMode - Type: string. Desc: dashboard, editor
     * @param {paidPlansAddedModalAppearParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.paidPlansAddedModalAppear = function (params) {
        return this.bi.log(__assign({ evid: 38 }, params));
    };
    /**
    * @typedef {Object} checkoutBuyNowButtonClickParams
    * @property {GUID} appInstanceId - Application ID
    * @property {GUID} biToken - null
    * @property {string} paymentProvider - Payment Provider (Paypal, Stripe, etc)
    * @property {GUID} planGuid - Plan Guid
    **/
    /**
     * Name: Checkout Buy Now Button click (deprecated). Evid: 42.
     * Event description: Buy now clicked from Checkout page.
    
     * appInstanceId - Type: guid. Desc: Application ID
     *
     * biToken - Type: guid.
     *
     * paymentProvider - Type: string. Desc: Payment Provider (Paypal, Stripe, etc)
     *
     * planGuid - Type: guid. Desc: Plan Guid
     * @param {checkoutBuyNowButtonClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.checkoutBuyNowButtonClick = function (params) {
        return this.bi.log(__assign({ evid: 42 }, params));
    };
    /**
    * @typedef {Object} memberProfilePaidPlansLoadedParams
    * @property {GUID} appInstanceId - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Member profile - Paid plans - Loaded. Evid: 25.
     * Event description: When the paid plans page of a DP member profile page was loaded.
    
     * appInstanceId - Type: guid.
     *
     * biToken - Type: guid.
     * @param {memberProfilePaidPlansLoadedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.memberProfilePaidPlansLoaded = function (params) {
        return this.bi.log(__assign({ evid: 25 }, params));
    };
    /**
    * @typedef {Object} membershipStatusLoadedParams
    * @property {GUID} appInstanceId - app instance id
    * @property {GUID} membershipId - membership_id
    * @property {string} membershipStatus - {approved,pending,denied} etc
    * @property {GUID} biToken - metasite id
    * @property {number} planID - plan_id
    * @property {string} role - {owner,member,visitor}
    * @property {GUID} site_member_id - site_member_id
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: membership status loaded (UoU). Evid: 18.
     * Event description: sent when memberships status loads after purchase.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * membershipId - Type: guid. Desc: membership_id
     *
     * membershipStatus - Type: string. Desc: {approved,pending,denied} etc
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * planID - Type: numeric. Desc: plan_id
     *
     * role - Type: string. Desc: {owner,member,visitor}
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {membershipStatusLoadedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.membershipStatusLoaded = function (params) {
        return this.bi.log(__assign({ evid: 18 }, params));
    };
    /**
    * @typedef {Object} cancelPlanClickParams
    * @property {GUID} appInstanceId - app instance id
    * @property {GUID} biToken - metasite id
    **/
    /**
     * Name: cancel plan click (deprecated). Evid: 7.
     * Event description: sent when the user clicks on 'cancel plan' in the plan form.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * biToken - Type: guid. Desc: metasite id
     * @param {cancelPlanClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.cancelPlanClick = function (params) {
        return this.bi.log(__assign({ evid: 7 }, params));
    };
    /**
    * @typedef {Object} membershipExpirationDateChangedParams
    * @property {GUID} appInstanceId - app instance id
    * @property {GUID} membershipId - membership guid
    * @property {GUID} biToken - metasite id
    * @property {GUID} planGuid - plan_guid
    * @property {number} planID - plan_id
    * @property {GUID} siteMemberId - site_member_id
    **/
    /**
     * Name: membership expiration date changed (deprecated). Evid: 14.
     * Event description: sent when a membership expiration date is changed.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * membershipId - Type: guid. Desc: membership guid
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * planGuid - Type: guid. Desc: plan_guid
     *
     * planID - Type: numeric. Desc: plan_id
     *
     * siteMemberId - Type: guid. Desc: site_member_id
     * @param {membershipExpirationDateChangedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.membershipExpirationDateChanged = function (params) {
        return this.bi.log(__assign({ evid: 14 }, params));
    };
    /**
    * @typedef {Object} pricingPlansAutopiliotLoadStatusesParams
    * @property {GUID} appId - null
    * @property {GUID} appInstanceId - null
    * @property {GUID} initiatorAppId - null
    * @property {GUID} biToken - null
    * @property {string} stage - Stages of installation between initiation and completion. (called/initiated/completed)
    **/
    /**
     * Name: Pricing Plans - Autopiliot load statuses. Evid: 71.
     * Event description: The event is designed to track autopilot performance in various stages of installation..
    
     * appId - Type: guid.
     *
     * appInstanceId - Type: guid.
     *
     * initiatorAppId - Type: guid.
     *
     * biToken - Type: guid.
     *
     * stage - Type: string. Desc: Stages of installation between initiation and completion. (called/initiated/completed)
     * @param {pricingPlansAutopiliotLoadStatusesParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.pricingPlansAutopiliotLoadStatuses = function (params) {
        return this.bi.log(__assign({ evid: 71 }, params));
    };
    /**
    * @typedef {Object} membershipAddedSuccessfullyParams
    * @property {GUID} appInstanceId - app instance id
    * @property {GUID} membershipId - membership guid
    * @property {GUID} biToken - metasite id
    * @property {GUID} planGuid - plan_guid
    * @property {GUID} site_member_id - site_member_id
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: membership added successfully (deprecated). Evid: 22.
     * Event description: when a membership is added successfully after the owner clicked on add new subscription.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * membershipId - Type: guid. Desc: membership guid
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * planGuid - Type: guid. Desc: plan_guid
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {membershipAddedSuccessfullyParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.membershipAddedSuccessfully = function (params) {
        return this.bi.log(__assign({ evid: 22 }, params));
    };
    /**
    * @typedef {Object} planClickOneAppParams
    * @property {GUID} appInstanceId - app instance id
    * @property {GUID} biToken - null
    * @property {GUID} planGuid - plan_guid
    * @property {string} role - {owner,member,visitor}
    * @property {GUID} site_member_id - site_member_id
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Plan Click - OneApp. Evid: 69.
     * Event description: sent when UoU clicks plan.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * biToken - Type: guid.
     *
     * planGuid - Type: guid. Desc: plan_guid
     *
     * role - Type: string. Desc: {owner,member,visitor}
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {planClickOneAppParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.planClickOneApp = function (params) {
        return this.bi.log(__assign({ evid: 69 }, params));
    };
    /**
    * @typedef {Object} memberProfilePaidPlansPlanLoadedParams
    * @property {GUID} appInstanceId - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Member profile - Paid plans - plan loaded. Evid: 27.
     * Event description: When a specific plan page was loaded in the member profile paid plans page.
    
     * appInstanceId - Type: guid.
     *
     * biToken - Type: guid.
     * @param {memberProfilePaidPlansPlanLoadedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.memberProfilePaidPlansPlanLoaded = function (params) {
        return this.bi.log(__assign({ evid: 27 }, params));
    };
    /**
    * @typedef {Object} memberProfilePaidPlansSwitchTabsParams
    * @property {GUID} appInstanceId - null
    * @property {string} currentTab - Active/Expired
    * @property {GUID} biToken - null
    * @property {string} targetTab - Active/Expired
    **/
    /**
     * Name: Member profile - Paid plans - switch tabs. Evid: 26.
     * Event description: When the user switches between Active and Expired tabs on the paid plans page on a member profile page.
    
     * appInstanceId - Type: guid.
     *
     * currentTab - Type: string. Desc: Active/Expired
     *
     * biToken - Type: guid.
     *
     * targetTab - Type: string. Desc: Active/Expired
     * @param {memberProfilePaidPlansSwitchTabsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.memberProfilePaidPlansSwitchTabs = function (params) {
        return this.bi.log(__assign({ evid: 26 }, params));
    };
    /**
    * @typedef {Object} widgetPlanOrderChangedParams
    * @property {GUID} appInstanceId - null
    * @property {GUID} biToken - null
    * @property {GUID} widgetId - widget id
    * @property {string} widgetType - pre-widget, list, single, button - widget types
    **/
    /**
     * Name: Widget - plan order changed. Evid: 58.
     * Event description: When User changes plan order in Editor widget settings.
    
     * appInstanceId - Type: guid.
     *
     * biToken - Type: guid.
     *
     * widgetId - Type: guid. Desc: widget id
     *
     * widgetType - Type: string. Desc: pre-widget, list, single, button - widget types
     * @param {widgetPlanOrderChangedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.widgetPlanOrderChanged = function (params) {
        return this.bi.log(__assign({ evid: 58 }, params));
    };
    /**
    * @typedef {Object} widgetClickOnPlanHideParams
    * @property {GUID} appInstanceId - null
    * @property {boolean} hidden - hidden: true/false
    * @property {GUID} biToken - null
    * @property {GUID} planGuid - plan guid
    * @property {GUID} widgetId - widget id
    * @property {string} widgetType - pre-widget, list, single, button - widget types
    **/
    /**
     * Name: Widget - click on plan hide. Evid: 57.
     * Event description: When user clicks hide/unhide plan checkbox in Editor widget settings.
    
     * appInstanceId - Type: guid.
     *
     * hidden - Type: bool. Desc: hidden: true/false
     *
     * biToken - Type: guid.
     *
     * planGuid - Type: guid. Desc: plan guid
     *
     * widgetId - Type: guid. Desc: widget id
     *
     * widgetType - Type: string. Desc: pre-widget, list, single, button - widget types
     * @param {widgetClickOnPlanHideParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.widgetClickOnPlanHide = function (params) {
        return this.bi.log(__assign({ evid: 57 }, params));
    };
    /**
    * @typedef {Object} preModalOpenedParams
    * @property {GUID} appInstanceId - app instance id
    * @property {string} formOrigin - indicates where the pre-modal was opened {bookings modal, blog modal, etc)
    * @property {GUID} biToken - metasite id
    * @property {string} origin - business manager open origin {editor, dashboard, etc}
    **/
    /**
     * Name: Paid Plans Premodal opened. Evid: 41.
     * Event description: sent when the pre modal is loaded.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * formOrigin - Type: string. Desc: indicates where the pre-modal was opened {bookings modal, blog modal, etc)
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * origin - Type: string. Desc: business manager open origin {editor, dashboard, etc}
     * @param {preModalOpenedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.preModalOpened = function (params) {
        return this.bi.log(__assign({ evid: 41 }, params));
    };
    /**
    * @typedef {Object} moreActionsItemClickParams
    * @property {string} actionName - {new purchase,email automations, manage payments}
    * @property {GUID} appInstanceId - app id
    * @property {GUID} biToken - null
    * @property {string} origin - dashboard/editor
    * @property {string} referralinfo - place where click came from
    **/
    /**
     * Name: more actions item click. Evid: 48.
     * Event description: sent when user clicks on one of the items in the more actions list.
    
     * actionName - Type: string. Desc: {new purchase,email automations, manage payments}
     *
     * appInstanceId - Type: guid. Desc: app id
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: dashboard/editor
     *
     * referralinfo - Type: string. Desc: place where click came from
     * @param {moreActionsItemClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.moreActionsItemClick = function (params) {
        return this.bi.log(__assign({ evid: 48 }, params));
    };
    /**
    * @typedef {Object} oaMessageOwnerToBuyPlanParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} biToken - msid
    * @property {GUID} planGuid - plan_guid
    **/
    /**
     * Name: OA - message owner to buy plan (deprecated). Evid: 37.
     * Event description: When the member clicks on message owner, in case the owner has no online payment connected.
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * planGuid - Type: guid. Desc: plan_guid
     * @param {oaMessageOwnerToBuyPlanParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaMessageOwnerToBuyPlan = function (params) {
        return this.bi.log(__assign({ evid: 37 }, params));
    };
    /**
    * @typedef {Object} connectModalOpenedParams
    * @property {GUID} appInstanceId - app instance id
    * @property {string} formOrigin - indicates where the form was opened {bookings, blog, forum  etc)
    * @property {GUID} biToken - metasite id
    * @property {string} origin - business manager open origin {editor, dashboard, etc}
    **/
    /**
     * Name: Connect modal opened. Evid: 43.
     * Event description: sent when connect modal is opened.
    
     * appInstanceId - Type: guid. Desc: app instance id
     *
     * formOrigin - Type: string. Desc: indicates where the form was opened {bookings, blog, forum  etc)
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * origin - Type: string. Desc: business manager open origin {editor, dashboard, etc}
     * @param {connectModalOpenedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.connectModalOpened = function (params) {
        return this.bi.log(__assign({ evid: 43 }, params));
    };
    /**
    * @typedef {Object} offlineFlowChooseAPlanForAMemberParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} biToken - msid
    * @property {GUID} planGuid - plan_guid
    * @property {GUID} site_member_id - site_member_id
    **/
    /**
     * Name: Offline Flow - choose a plan for a member. Evid: 31.
     * Event description: When the user (owner) select a plan for owner.
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * planGuid - Type: guid. Desc: plan_guid
     *
     * site_member_id - Type: guid. Desc: site_member_id
     * @param {offlineFlowChooseAPlanForAMemberParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.offlineFlowChooseAPlanForAMember = function (params) {
        return this.bi.log(__assign({ evid: 31 }, params));
    };
    /**
    * @typedef {Object} creationFormCtaClickParams
    * @property {string} action - name of the action {connect payment, see more options}
    * @property {GUID} appInstanceId - null
    * @property {GUID} biToken - null
    * @property {string} origin - dashboard/ editor
    * @property {string} referralInfo - null
    **/
    /**
     * Name: Connect CTA click (Ready funnel). Evid: 53.
     * Event description: sent when Connect CTA clicked anywhere within Pricing Plans. Used for promoting Connect Payment.
    
     * action - Type: string. Desc: name of the action {connect payment, see more options}
     *
     * appInstanceId - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: dashboard/ editor
     *
     * referralInfo - Type: string.
     * @param {creationFormCtaClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.creationFormCtaClick = function (params) {
        return this.bi.log(__assign({ evid: 53 }, params));
    };
    /**
    * @typedef {Object} paidPlansAddPurchaseChooseClientAddNewClientParams
    * @property {GUID} appInstanceId - null
    * @property {boolean} isNewMember - true or false
    * @property {GUID} biToken - null
    * @property {GUID} site_member_id - site_member_id
    **/
    /**
     * Name: Offline Flow - choose member. Evid: 30.
     * Event description: When the user (owner) selects client in order to add a purchase for him.
    
     * appInstanceId - Type: guid.
     *
     * isNewMember - Type: bool. Desc: true or false
     *
     * biToken - Type: guid.
     *
     * site_member_id - Type: guid. Desc: site_member_id
     * @param {paidPlansAddPurchaseChooseClientAddNewClientParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.paidPlansAddPurchaseChooseClientAddNewClient = function (params) {
        return this.bi.log(__assign({ evid: 30 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
function getLoggerConf() {
    return {
        src: 92,
        endpoint: 'membership',
    };
}
exports.getLoggerConf = getLoggerConf;
//# sourceMappingURL=index.js.map